import React from "react";
import { useNavigate } from "react-router-dom";
import WriteBox from "../../QuestionPage/WordBox";
import QuestionBox from "../../QuestionPage/questionbox";
import { useState, useEffect } from "react";
import MCQQuestion from "../../QuestionPage/Mcq";
import FillInTheBlanksDraggable from "../../QuestionPage/FillInTheBlanksDraggable";

// Fetching Data from the API]

// End

// Page Html
export default function ReadingFillInTheBlanksMockPage({ question ,onInputChange,questionNumber,maxQuestion}) {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [originalWords, setOriginalWords] = useState("");
  const [Options, setOptions] = useState([]);
  const [replacedOptions, setReplacedOptions] = useState([]);
  const [submittedOptions, setSubmittedOptions] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    // Reset replacedOptions whenever question changes
    setReplacedOptions([]);
  }, [question]);

  useEffect(() => {
    // Set the state when the question prop changes
    setOriginalWords(question.question);
    setOptions(question.option.map(option => option.options)); // Extracting options array

  }, [question]);
    // Ensure onInputChange is called whenever submittedOptions changes
    useEffect(() => {
      if (submittedOptions !== "") {
        onInputChange(submittedOptions);
        console.log("submittedOptions", submittedOptions);
      }
    }, [submittedOptions]);

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
        Question {questionNumber} of {maxQuestion}
        </h2>
        <p className="p-2">
        You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.
        </p>
        <FillInTheBlanksDraggable
            sentence={originalWords}
            options={Options}
            submitted={submitted}
            onOptionsChange={setSubmittedOptions}
          />

      </div>
    </div>
  );
}
